import { render } from "./indexPropertyTypesComponent.vue?vue&type=template&id=0a57275e"
import script from "./indexPropertyTypesComponent.vue?vue&type=script&lang=js"
export * from "./indexPropertyTypesComponent.vue?vue&type=script&lang=js"

import "./indexPropertyTypesComponent.vue?vue&type=style&index=0&id=0a57275e&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__